var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.test ? '' : 'homeRef',class:{ position: !_vm.test },attrs:{"id":"home"}},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"bg-fize"},[_vm._v(_vm._s(_vm.bgName))]),(_vm.loading)?_c('dv-loading',[_vm._v("Loading...")]):_c('div',{staticClass:"host-body d-flex jc-center"},[_c('left'),_c('center'),_c('right')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }